/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/23/2016
 * Time: 1:10 PM
 */
import keymirror from 'keymirror';

const CommonActions = keymirror({
  MESSAGES_LOADED: null,
  LOCALE_CHANGED: null,
});

export default CommonActions;



/** WEBPACK FOOTER **
 ** ./src/main/js/common/constants/CommonActions.js
 **/